import FundsHeader from "./FundsHeader";

export default FundsHeader;
